import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function CallbackPage() {
  const [error, setError] = useState('');
  const { handleCallback } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const errorParam = params.get('error');
    const errorDesc = params.get('error_description');

    if (errorParam) {
      const msg = errorDesc || errorParam;
      navigate('/login?error=' + encodeURIComponent(msg), { replace: true });
      return;
    }

    if (!code) {
      navigate('/login?error=' + encodeURIComponent('No authorization code received'), { replace: true });
      return;
    }

    const redirectUri = window.location.origin + '/callback';

    handleCallback(code, redirectUri)
      .then(() => {
        navigate('/', { replace: true });
      })
      .catch((err) => {
        const msg = err.response?.data?.error || 'Authentication failed';
        navigate('/login?error=' + encodeURIComponent(msg), { replace: true });
      });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-100 via-white to-cyan-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600 mx-auto mb-4"></div>
        <p className="text-sm text-gray-600 dark:text-gray-400">Authenticating with secure server...</p>
        {error && <p className="text-sm text-red-500 mt-2">{error}</p>}
      </div>
    </div>
  );
}
